module.exports = __webpack_public_path__ + "static/escrow-45d2dcd6a54c3a29405392ac5971490d.jpg";